import { render, staticRenderFns } from "./StatiscsBank.vue?vue&type=template&id=b755800c&scoped=true&"
import script from "./StatiscsBank.vue?vue&type=script&lang=js&"
export * from "./StatiscsBank.vue?vue&type=script&lang=js&"
import style0 from "./StatiscsBank.vue?vue&type=style&index=0&id=b755800c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b755800c",
  null
  
)

export default component.exports